import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { BsArrowUpRight, BsArrowDownLeft } from "react-icons/bs";
import moment from "moment";

const CustomerGrowthChart = ({ customers = [] }) => {
  // Group new customers by day
  const customerData = useMemo(() => {
    const grouped = {};

    customers.forEach((c) => {
      const date = moment(c.createdAt).format("YYYY-MM-DD");
      grouped[date] = (grouped[date] || 0) + 1;
    });

    return Object.entries(grouped)
      .map(([date, count]) => ({ date, count }))
      .sort((a, b) => new Date(a.date) - new Date(b.date));
  }, [customers]);

  const total = customers.length;
  const last = customerData.at(-1)?.count || 0;
  const prev = customerData.at(-2)?.count || 0;
  const diff = last - prev;
  const growth = diff > 0;

  return (
    <div className="bg-drylight dark:bg-neutral-800 rounded-xl border border-border p-5 shadow w-full">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-base font-semibold text-yellowdark">
          Customer Growth
        </h2>
        <div className="flex items-center gap-2 text-sm text-textGray">
          <span className="font-semibold text-lg text-text">{total}+</span>{" "}
          Total Customers
          {diff !== 0 && (
            <span
              className={`flex items-center ml-2 font-medium ${
                growth ? "text-green-500" : "text-red-500"
              }`}
            >
              {growth ? <BsArrowUpRight /> : <BsArrowDownLeft />}
              <span className="ml-1">
                {growth ? "+" : ""}
                {diff} today
              </span>
            </span>
          )}
        </div>
      </div>

      <div className="h-64 w-full mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={customerData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 10 }}
              tickFormatter={(d) => moment(d).format("MMM D")}
              stroke="#fed693"
            />
            <YAxis stroke="#fed693" />
            <Tooltip
              labelFormatter={(label) => moment(label).format("MMMM D, YYYY")}
            />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#fed693"
              strokeWidth={2}
              dot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CustomerGrowthChart;
